import { Component } from '@angular/core';
import { PortalDeterminationService } from '@core/services/portal-determination.service';

@Component({
  selector: 'gc-login-extras',
  templateUrl: './login-extras.component.html',
  styleUrls: ['./login-extras.component.scss']
})
export class LoginExtrasComponent {
  isBBGMApplicant = false;

  constructor (
    private portal: PortalDeterminationService
  ) {
    this.isBBGMApplicant = this.portal.isBBGMApplicant();
  }
}
